import { createApi } from '@reduxjs/toolkit/query/react'

import { customFetchBaseQuery } from '@/utils/api'
import { PRODUCT } from '@/utils'
import type {
  AddCreditCardPayload,
  GetPricePreviewParams,
  GetPricePreviewResponse,
} from './interfaces'
import { HttpMethod } from '@/constants/utils'
import isEmpty from 'lodash/isEmpty'
import omitBy from 'lodash/omitBy'

export const billingApi = createApi({
  reducerPath: 'billingApi',
  baseQuery: customFetchBaseQuery({
    baseUrl: process.env.GATSBY_BILLING_API_URL,
  }),
  endpoints: ({ query, mutation }) => ({
    getPricePreview: query<GetPricePreviewResponse, GetPricePreviewParams>({
      query: ({ price, productType = PRODUCT.LiveChat, country, zip }) => {
        const params = omitBy(
          {
            price: String(price),
            country,
            zip,
          },
          isEmpty
        ) as Record<string, string>

        const urlParams = new URLSearchParams(params)

        return { path: `/price_preview/${productType}?${urlParams}` }
      },
      keepUnusedDataFor: 60 * 5, // 5 minutes
    }),
    addCreditCard: mutation<unknown, AddCreditCardPayload>({
      query: ({ product, ...payload }) => ({
        path: `/account/${product}`,
        method: HttpMethod.POST,
        body: payload,
      }),
    }),
  }),
})

export const {
  useGetPricePreviewQuery,
  useLazyGetPricePreviewQuery,
  useAddCreditCardMutation,
  reducer,
  reducerPath,
  middleware,
  endpoints: billingApiEndpoints,
} = billingApi
